import React from 'react'
import { Image, StyleSheet } from 'react-native'

import { useModal } from '@zet/common/hooks/useModal'
import { B2, B3, SH1, SH3, Stack, XStack, colors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import Download from '@zet/design-system/svg/Download'
import { i18n } from '@zet/localization'
import { DEVICE_HEIGHT } from '@zet/utils/Constants'

import { IBrandComsData } from '../../../api/brands/types'
import { Pdf } from '../../../assets/svg'
import { defaultThumbnail } from '../../../utils/constants'

const ApplicationProcess = ({
  content,
}: {
  content: IBrandComsData | undefined
}) => {
  const { openModal } = useModal()
  function openVideoModal() {
    openModal('WebVideoPlayerModal', {
      videoId: content?.applicationProcess?.videoLink,
    })
  }
  function openPdfFile() {
    window.open(content?.applicationProcess?.pdfLink)
  }
  return (
    <Stack className="bg-neutral-white100 mb-6 mt-1 p-3">
      <SH3 className="text-grays-80 mb-2 font-[Graphie-Bold]">
        {i18n.t('navigationHeading.applicationProcess')}
      </SH3>
      <SH1 className="text-grays-80 font-[Graphie-Bold]">
        {i18n.t('applicationProcess.heading', { bankName: content?.name })}
      </SH1>
      <B3 className="text-grays-60 mb-2 pr-4" style={{ lineHeight: '1.20rem' }}>
        {i18n.t('productFlow.detailedStep', { bankName: content?.name })}
      </B3>
      <Pressable
        className="mb-2 overflow-hidden rounded-xl"
        style={styles.videoThumbnail}
        onPress={openVideoModal}
      >
        <Image
          source={{
            uri: content?.applicationProcess?.thumbnail || defaultThumbnail,
          }}
          resizeMode="cover"
          className="h-full w-full"
        />
      </Pressable>
      {Boolean(content?.applicationProcess?.pdfLink) && (
        <XStack className="border-grays-40 items-center justify-between rounded-lg border p-2">
          <Stack className="mr-2">
            <Pdf />
          </Stack>
          <Stack className="flex-1">
            <SH3 className="text-grays-80">
              {i18n.t('brandShareDetails.process.booklet')}
            </SH3>
            <B2 className="text-grays-70">
              {i18n.t('applicationProcess.process_step', {
                bankName: content?.name,
              })}
            </B2>
          </Stack>
          <Pressable
            className="bg-primary-10 rounded-lg p-2"
            onPress={openPdfFile}
          >
            <Download size={16} color={colors.primary[100]} />
          </Pressable>
        </XStack>
      )}
    </Stack>
  )
}
const styles = StyleSheet.create({
  videoThumbnail: { height: DEVICE_HEIGHT * 0.2 },
  detailedStep: {},
})
export { ApplicationProcess }
